module.exports = __webpack_public_path__ + "i18n/ru_b21f4e34fe3235ac468f5a9c2226b357.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ru.json
// module id = 2MCb
// module chunks = 151